import { SVGProps } from 'react';

const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M4.94 5.73 4 6.67l4 4 4-4-.94-.94L8 8.783 4.94 5.73Z" />
    </svg>
);
export default SvgChevronDown;
